export const weddingStoriesFaqIds = ['wsf1', 'wsf2', 'wsf3', 'wsf4', 'wsf5']